import React, {Suspense, lazy } from 'react';
import './App.css';
import PrivateRoute from './components/PrivateRoutes/PrivateRoutes';

import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
//import Addtomanifestp from './components/chatbotportal/pages/addtomanifest';

//import Logincbt from './components/mainpage/pages/Login';
const Logincbt = lazy(() => import('./components/mainpage/pages/Login'))
//import Addusersp from './components/chatbotportal/pages/addusers';
const Addusersp = lazy(() => import('./components/chatbotportal/pages/addusers'))
//import Uploadassignments from './components/chatbotportal/pages/uploadassignment';
const Uploadassignments = lazy(() => import('./components/chatbotportal/pages/uploadassignment'))
//import Schedulerpage from './components/chatbotportal/pages/scheduler';
const Schedulerpage = lazy(() => import('./components/chatbotportal/pages/scheduler'))
//import Addgroupp from './components/chatbotportal/pages/groups';
const Addgroupp = lazy(() => import('./components/chatbotportal/pages/groups'))
//import Studentreportp from './components/chatbotportal/pages/studentreport';
const Studentreportp = lazy(() => import('./components/chatbotportal/pages/studentreport'))
//import Payslip from './components/chatbotportal/pages/payslips';
const Payslip = lazy(() => import('./components/chatbotportal/pages/payslips'))
//import Uploadtimetables from './components/chatbotportal/pages/uploadtimetable';
const Uploadtimetables = lazy(() => import('./components/chatbotportal/pages/uploadtimetable'))
//import Uploadnotespage from './components/chatbotportal/pages/uploadnotes';
const Uploadnotespage = lazy(() => import('./components/chatbotportal/pages/uploadnotes'))
//import Uploadannouncementpage from './components/chatbotportal/pages/announcement';
const Uploadannouncementpage = lazy(() => import('./components/chatbotportal/pages/announcement'))
//import Uploadeventspage from './components/chatbotportal/pages/events';
const Uploadeventspage = lazy(() => import('./components/chatbotportal/pages/events'))
///import Enquirypage from './components/chatbotportal/pages/enquiry';
const Enquirypage = lazy(() => import('./components/chatbotportal/pages/enquiry'))

const Travelersmanifest = lazy(() => import('./components/chatbotportal/pages/uploadmanifest'))

const Sendstartmessage = lazy(() => import('./components/chatbotportal/pages/sendstartmessage'))

const Triviaoffset= lazy(() => import('./components/chatbotportal/pages/triviaoffset'))

const Scanticket = lazy(() => import('./components/chatbotportal/pages/scanticket'))

const Manifest = lazy(() => import('./components/chatbotportal/pages/manifest'))

const Addtomanifestp = lazy(() => import('./components/chatbotportal/pages/addtomanifest'))

const Addbulktomanifestp = lazy(() => import('./components/chatbotportal/pages/addbulktomanifest'))

const Newaddmemberp = lazy(() => import('./components/chatbotportal/pages/newaddmember'))

const Dashboardp = lazy(() => import('./components/chatbotportal/pages/dashboard'))

const RouteDashboardp = lazy(() => import('./components/chatbotportal/pages/routedashboard'))

const PassengerTrendsDashboardp = lazy(() => import('./components/chatbotportal/pages/passengerdashboard'))

const RevenueDashboardp = lazy (() => import('./components/chatbotportal/pages/revenuedashboard'))

const QuizDashboardp = lazy(() => import('./components/chatbotportal/pages/quizdashboard'))

const BotDashboardp = lazy(() => import('./components/chatbotportal/pages/botdashboard'))

const CustomerTraveldashboardp = lazy(() => import('./components/chatbotportal/pages/customerTraveldashboard'))

const App = () => {
    return (
       <>
        <Router>
            <Suspense fallback={<div>Loading...</div>}>
                <Routes>
                    <Route path='/' element={<Logincbt />} />

                    <Route path='/addusers' element={
                        <PrivateRoute element={<Addusersp />} role={['itstaff','admin' ]} />
                    } />

                    <Route path='/addmembers' element={
                        <PrivateRoute element={<Newaddmemberp />} role={['itstaff','admin']} />
                    } />

                    <Route path='/dashboard' element={
                        <PrivateRoute element={<Dashboardp />} role={['itstaff','admin']} />
                    } />

                    
                     <Route path='/botdashboard' element={
                        <PrivateRoute element={<BotDashboardp />} role={['itstaff','admin']} />
                    } />

                    
                    <Route path='/traveldashboard' element={
                        <PrivateRoute element={<CustomerTraveldashboardp />} role={['itstaff','admin']} />
                    } />

                    <Route path='/routedashboard' element={
                        <PrivateRoute element={<RouteDashboardp />} role={['itstaff','admin']} />
                    } />

                     <Route path='/passengerdashboard' element={
                        <PrivateRoute element={<PassengerTrendsDashboardp />} role={['itstaff','admin']} />
                    } />

                    <Route path='/revenuedashboard' element={
                        <PrivateRoute element={<RevenueDashboardp />} role={['itstaff','admin']} />
                    } />
                    
                     <Route path='/quizdashboard' element={
                        <PrivateRoute element={<QuizDashboardp />} role={['itstaff','admin']} />
                    } />

                    <Route path='/uploadassignment' element={
                        <PrivateRoute element={<Uploadassignments />} role={['itstaff','staff', 'admin']} />
                    } />

                    <Route path='/scheduler' element={
                        <PrivateRoute element={<Schedulerpage />} role={['itstaff','admin']} />
                    } />

                    <Route path='/groups' element={
                        <PrivateRoute element={<Addgroupp />} role={['itstaff','admin']} />
                    } />

                    <Route path='/studentreport' element={
                        <PrivateRoute element={<Studentreportp />} role={['itstaff','admin']} />
                    } />

                    <Route path='/payslip' element={
                        <PrivateRoute element={<Payslip />} role={['itstaff','admin']} />
                    } />

                    <Route path='/uploadtimetable' element={
                        <PrivateRoute element={<Uploadtimetables />} role={['itstaff','admin']} />
                    } />

                    <Route path='/uploadnotes' element={
                        <PrivateRoute element={<Uploadnotespage />} role={['itstaff','admin']} />
                    } />

                    <Route path='/uploadannouncements' element={
                        <PrivateRoute element={<Uploadannouncementpage />} role={['itstaff','admin']} />
                    } />

                    <Route path='/uploadevents' element={
                        <PrivateRoute element={<Uploadeventspage />} role={['itstaff','admin']} />
                    } />

                    <Route path='/enquiry' element={
                        <PrivateRoute element={<Enquirypage />} role={['itstaff','admin']} />
                    } />

                    <Route path='/addmanifest' element={
                        <PrivateRoute element={<Travelersmanifest />} role={['itstaff','staff','admin']} />
                    } />

                    <Route path='/sendstartmessage' element={
                        <PrivateRoute element={<Sendstartmessage />} role={['itstaff','admin']} />
                    } />

                    <Route path='/triviaoffset' element={
                        <PrivateRoute element={<Triviaoffset />} role={['itstaff','admin']} />
                    } />

                    <Route path='/scanticket' element={
                        <PrivateRoute element={<Scanticket />} role={['itstaff','staff','admin']} />
                    } />

                    <Route path='/manifest' element={
                        <PrivateRoute element={<Manifest />} role={['itstaff','staff','admin']} />
                    } />

                    <Route path='/addtomanifest' element={
                        <PrivateRoute element={<Addtomanifestp />} role={['itstaff','admin']} />
                    } />

                    <Route path='/addbulktomanifest' element={
                        <PrivateRoute element={<Addbulktomanifestp />} role={['itstaff','admin']} />
                    } />
                </Routes>
            </Suspense>   
        </Router>
       </>
    )
}

export default App;

